<template>
  <div>
    <section class="socials-header">
      <div class="socials-header__title">{{ activePage.heading_text }}</div>
      <div
        class="socials-header__subtitle"
        v-html="activePage.intro_text"
      ></div>
    </section>
    <section class="socials-holder">
      <div id="flockler-embed-177d56e3a7002874d3d9d665deea9168"></div>
    </section>
  </div>
</template>

<script>
export default {
  name: "SocialsPage",
  metaInfo: {
    titleTemplate: "%s",
  },
  mounted() {
    this.setPageContext("socials", () => {});
    let flocklerScript = document.createElement("script");
    flocklerScript.setAttribute(
      "src",
      "https://plugins.flockler.com/embed/17306b20f4806af0ee967ed6c0e66236/177d56e3a7002874d3d9d665deea9168"
    );
    document.head.appendChild(flocklerScript);
  },
};
</script>

<style scoped lang="scss">
.socials-header {
  background: linear-gradient(0deg, $jude-darkred, $jude-darkred),
    url(~@/assets/ripple.jpg);
  background-blend-mode: multiply, normal;
  mix-blend-mode: darken;
  background-position: center;
  background-size: cover;
  padding: 54px 40px;
  text-align: center;
  color: white;

  &__title {
    font-weight: 800;
    font-size: 64px;
    line-height: 73px;
  }
  &__subtitle {
    font-size: 18px;
    line-height: 24px;
    margin-top: 15px;
  }
}

.socials-holder {
  background-color: white;
  padding: 50px 120px;
}

@media screen and (max-width: 960px) {
  .socials-holder {
    background-color: white;
    padding: 50px 20px;
  }

  .socials-header {
    &__title {
      font-size: 36px;
    }
  }
}
</style>
